import { useChatStore } from './chat.store';
import { useCoachStore } from './coach.store';
import { useCovenantStore } from './covenant.store';
import { useIntroStore } from './intro.store';
import { useJournalStore } from './journal.store';
import { useNotificationPrefsStore } from './notification-prefs.store';
import { usePersonalityStore } from './personality.store';
import { useProgressStore } from './progress.store';
import { useRitualStore } from './ritual.store';

/**
 * Wipe every per-user local Zustand store back to its initial state. Called on
 * signout (in `use-boot-sync.ts`) and on the Profile "Reset" button.
 *
 * The contract: this is the ONE place to register a store that holds user
 * data. When you add a new store, add it here too — otherwise the next user
 * on the same browser, or the same user after tapping Reset, will see stale
 * state leak through.
 *
 * Do NOT add UI-only stores. They intentionally survive a reset:
 *   - `useI18nStore` — locale is a UI preference, not user data.
 *   - `useUiStore`   — transient draft input; nothing user-identifying.
 *
 * Uses `getState().reset()` (Zustand's vanilla API) so callers don't need to
 * subscribe to every store just to invoke a one-shot action.
 */
export function resetAllUserStores() {
  useCoachStore.getState().reset();
  useCovenantStore.getState().reset();
  useRitualStore.getState().reset();
  useProgressStore.getState().reset();
  useJournalStore.getState().reset();
  useIntroStore.getState().reset();
  usePersonalityStore.getState().reset();
  useChatStore.getState().reset();
  useNotificationPrefsStore.getState().reset();
}
